import PostDynamicFormRequestModelBase from '../_generated/modelBases/post-dynamic-form-request-model-base';

export default class PostDynamicFormRequestModel extends PostDynamicFormRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
